import type { BoxProps } from '@mui/material';

import { AppBar, Box, Toolbar } from '@mui/material';
// @mui
import { useTheme } from '@mui/material/styles';

// components
import Logo from '../../components/logo';
// config
import { HEADER } from '../../config-global';
// utils
import { bgBlur } from '../../utils/cssStyles';

// ----------------------------------------------------------------------

type Props = {
  isOffset: boolean;
};

const Header = ({ isOffset }: Props) => {
  const theme = useTheme();

  return (
    <AppBar color="transparent" sx={{ boxShadow: 0 }}>
      <Toolbar
        sx={{
          height: {
            md: HEADER.H_MAIN_DESKTOP,
            xs: HEADER.H_MOBILE,
          },
          justifyContent: 'space-between',
          transition: theme.transitions.create(['height', 'background-color'], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeInOut,
          }),
          ...(isOffset && {
            ...bgBlur({ color: theme.palette.background.default }),
            height: {
              md: HEADER.H_MAIN_DESKTOP - 16,
            },
          }),
        }}
      >
        <Logo sx={{ justifyContent: 'flex-start' }} />
      </Toolbar>

      {isOffset && <Shadow />}
    </AppBar>
  );
};

export default Header;

const Shadow = ({ sx, ...other }: BoxProps) => {
  return (
    <Box
      sx={{
        borderRadius: '50%',
        bottom: 0,
        boxShadow: (theme) => theme.customShadows.z8,
        height: 24,
        left: 0,
        m: 'auto',
        position: 'absolute',
        right: 0,
        width: `calc(100% - 48px)`,
        zIndex: -1,
        ...sx,
      }}
      {...other}
    />
  );
};
